<template>
  <h1 class="text-[24px] lg:text-[30px] uppercase text-center">{{ title }}</h1>
</template>

<script>
export default {
  name: 'TitleComponent',
  props: {
    title: {
      type: String,
      default: 'Title',
    },
  },
};
</script>

<style></style>
